import { render } from "./house-type.vue?vue&type=template&id=1a452f72&scoped=true"
import script from "./house-type.vue?vue&type=script&lang=js"
export * from "./house-type.vue?vue&type=script&lang=js"

import "./house-type.vue?vue&type=style&index=0&id=1a452f72&lang=scss&scoped=true"

import exportComponent from "/www/publicHouse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a452f72"]])

export default __exports__